import React from 'react';
import styled from 'styled-components';
import {CONSTS} from './_constants';

const Icon = ({className, icon}) => (
    <span className={`${className} icon-${icon}`}></span>
)
const StyledIcon = styled(Icon)`
    font-family: 'snappion';
    ${props => (`
        ${props.primary ? `color:${CONSTS.colors.primary}` : ""}    
        ${props.warning ? `color:${CONSTS.colors.warning}` : ""}
        ${props.error ? `color:${CONSTS.colors.error}` : ""}
        ${props.success ? `color:${CONSTS.colors.success}` : ""}
    `)}
`
export default StyledIcon;